const actions = {
	SET_USER: "SET_USER"
};

export default actions;
